
export default {
    staged: [],
    collection: [],
    cart: [],
};
